var exports = {
  "tiles": "tiles-RV8xO",
  "tile": "tile-RV8xO",
  "short": "short-RV8xO",
  "bg": "bg-RV8xO",
  "bottom": "bottom-RV8xO",
  "full": "full-RV8xO",
  "caption": "caption-RV8xO",
};

__webpack_require__.r(module.exports = exports);
